import ChangePhoneForm from '@features/games/profile/phone-number/change-phone-form/change-phone-form';
export default ChangePhoneForm;
